import { ReactNode, useCallback, useEffect, useState } from 'react';

import { CKO_PUBLIC_KEY, RISK_SCRIPT_URL } from 'config';
import { loadScript } from 'lib/script';

import { RiskJsContext } from '.';

// This provider is responsible for loading the Risk.js script and initializing the Risk instance
// Recommanded by Checkout.com to collect device data before processing a payment
interface Props {
  children: ReactNode;
}

interface RiskInstance {
  publishRiskData: () => Promise<string>;
}

declare global {
  interface Window {
    Risk?: {
      init: (publicKey: string) => RiskInstance;
    };
  }
}

export const RiskJsProvider = ({ children }: Props) => {
  const [riskInstance, setRiskInstance] = useState<RiskInstance | undefined>();
  const init = useCallback(() => {
    loadScript(RISK_SCRIPT_URL).then(async () => {
      if (window.Risk) {
        const b = window.Risk.init(CKO_PUBLIC_KEY);
        setRiskInstance(b);
      }
    });
  }, []);

  useEffect(() => {
    if (!process.env.TEST_ENV) {
      init();
    }
  }, [init]);

  return (
    <RiskJsContext.Provider
      value={{
        riskInstance,
      }}
    >
      {children}
    </RiskJsContext.Provider>
  );
};
